/* src/app/shared/components/flow-card/flow-card.component.scss */
.card-container {
  width: 633px;
  height: 76px;
  background-color: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 12px;
}
.card-container .card-header {
  padding: 16px;
  width: 100%;
}
.card-container .divider {
  height: 1px;
  width: 100%;
  background-color: #d4d4d8;
}
.card-container .card-body {
  padding: 16px;
  width: 100%;
  height: fit-content;
}
/*# sourceMappingURL=flow-card.component.css.map */
